import React from 'react';
import { PreliminarySection } from '../preliminary_section.jsx';
import { useFlowStore, useFlowRegistry } from '../../store/react';
import { selectCurrentItem } from '../../store/selectors';
import { getParentLoopName } from '../../utils.js';

export default function PreliminarySectionWrapper({ sectionName }) {
    const registry = useFlowRegistry();
    const setLoopPreliminary = useFlowStore((s) => s.setLoopPreliminary);
    const currentItem = useFlowStore((s) => selectCurrentItem(s, registry));
    const loops = useFlowStore((s) => s.loops);
    if (!currentItem || !currentItem.loopName) return null;
    const parentName = getParentLoopName(currentItem.loopName);
    const parent = parentName ? loops[parentName] : loops[currentItem.loopName];
    const marked = (parent && parent.markedAsPreliminary && parent.markedAsPreliminary[parent.index - 1]) || false;
    return (
        <PreliminarySection
            marked={marked}
            sectionName={sectionName}
            toggleSectionPreliminary={() => setLoopPreliminary(currentItem.loopName)}
        />
    );
}
